import { useEffect, useState } from "react";
import { BoardAiApi, BoardAiCapabilities } from "../../../services/board-ai-api";

// Whether the deployment has an AI model configured. Queried once per session and cached, so the
// many AI affordances scattered across the board don't each fire a request. Components use this to
// hide their AI buttons entirely when AI is off (the backend also enforces it).
let cached: Promise<boolean> | null = null;

function fetchEnabled(): Promise<boolean> {
  if (cached === null) {
    cached = BoardAiApi.getCapabilities()
      .then((caps: BoardAiCapabilities): boolean => caps.enabled)
      .catch((): boolean => false);
  }
  return cached;
}

export function useBoardAiEnabled(): boolean {
  const [enabled, setEnabled] = useState<boolean>(false);

  useEffect((): (() => void) => {
    let active: boolean = true;
    void fetchEnabled().then((value: boolean): void => {
      if (active) {
        setEnabled(value);
      }
    });
    return (): void => {
      active = false;
    };
  }, []);

  return enabled;
}
